/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Icon } from 'chakra-v3';
import { BsPersonCheckFill, BsCircle, BsShieldCheck } from 'react-icons/bs';
import { withBaseUrl } from '../utils/url';

export const LOGOS = [
  // These may change in the future, depending on the sales team
  { name: 'OTS GOI', src: withBaseUrl('/GOI_logo.svg') },
  { name: 'Microsoft', src: withBaseUrl('/Microsoft_logo.svg') },
  { name: 'Gates Foundation', src: withBaseUrl('/gates_foundation_logo.svg') },
  { name: 'Google', src: withBaseUrl('/google_logo.svg') },
  { name: 'Wadhwani AI', src: withBaseUrl('/wadhwani_ai_logo.svg') },
  { name: 'OLA', src: withBaseUrl('/ola_logo.svg') },
];

export const foundationFeatures = [
  {
    icon: <Icon as={BsPersonCheckFill} boxSize="40px" color="text.teal" />,
    title: 'Verified raters',
    description: 'Every participant is identity-verified and profiled by domain, education and linguistic expertise.',
  },
  {
    icon: <Icon as={BsCircle} boxSize="40px" color="text.teal" />,
    title: 'Transparent methodologies',
    description: 'Evaluation protocols, sampling methods and rubrics are consistently documented and traceable',
  },
  {
    icon: <BsShieldCheck size={40} color="text.teal" />,
    title: 'Independent governance',
    description: 'As a non-profit initiative, Karya upholds impartiality and fairness in every study',
  },
];

export const numberedFeatures = [
  {
    number: '01',
    title: 'Pairwise evaluation',
    description: 'Compare two model responses to a prompt and record preferences or qualitative judgments.',
    colStart: { base: 1, lg: 2 },
    rowStart: { base: 2, lg: 1 },
  },
  {
    number: '02',
    title: 'Structured rubrics',
    description: 'Apply detailed scoring criteria spanning factual accuracy, reasoning, tone and clarity.',
    colStart: { base: 1, lg: 3 },
    rowStart: { base: 3, lg: 1 },
  },
  {
    number: '03',
    title: 'Multilingual coverage',
    description: 'Conduct evaluations in more than twenty Indic and international languages.',
    colStart: { base: 1, lg: 1 },
    rowStart: { base: 4, lg: 2 },
  },
  {
    number: '04',
    title: 'Automated quality checks',
    description: 'Employ built-in validation to flag duplicates or incomplete responses.',
    colStart: { base: 1, lg: 2 },
    rowStart: { base: 5, lg: 2 },
  },
  {
    number: '05',
    title: 'Analytics and reporting',
    description: 'Access transparent logs, rater reliability indicators and summarised dashboards.',
    colStart: { base: 1, lg: 3 },
    rowStart: { base: 6, lg: 2 },
  },
];

export const steps = [
  {
    number: 1,
    title: 'Define your study',
    description: 'Upload prompts, model outputs, rubrics',
  },
  {
    number: 2,
    title: 'Select verified raters',
    description: 'Filter by language, domain, expertise',
  },
  {
    number: 3,
    title: 'Run and review',
    description: 'Track progress, export datasets',
  },
];

export const caseStudies = [
  {
    title: 'SAMIKSHA',
    description: 'Assessment of generative models on civic reasoning and cultural understanding.',
    href: import.meta.env.VITE_SAMIKSHA_URL || '#',
  },
];
